import React from 'react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Segment, Header} from 'semantic-ui-react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import {format} from 'path';
import _ from 'lodash';
import {convertDateForDisplay, convertValueToDollar} from 'common/utils';

export class FundingInformationTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commitments: [],
      error: false,
    };
  }

  UNSAFE_componentWillMount() {
    let commitmentIds = [];
    if (_.get(this.props, 'processVariables.subGrantCommitments')) {
      commitmentIds.push(_.get(this.props, 'processVariables.commitmentId'));
    } else if (_.get(this.props, 'awardRecommendation.payload.commitment')){
      let commitments = _.get(this.props, 'awardRecommendation.payload.commitment')
      if (!Array.isArray(commitments)) {
        commitments = [commitments]
      }
      commitmentIds = _.map(commitments, commitment =>(commitment.commitmentNumberId))
    } else {
      commitmentIds = _.get(this.props, 'fundingOpportunityData.commitmentNumbers')
    }

    if (!commitmentIds) {
      this.setState({error: true});
    } else {
      _.forEach(commitmentIds, (id) => {
        this.props.getCommitment(this.props.token, id).then((res) => {
          const commitmentDetails = res.payload.commitmentDetailsResponse[0];
          commitmentDetails.commitmentLineNumber = formatLineNumber(
            commitmentDetails.commitmentLineNumber.toString()
          );

          this.setState({
            commitments: [...this.state.commitments, commitmentDetails],
          });
        });
      });
    }
  }

  render() {
    let {commitments, error} = this.state;
    const {headerSize} = this.props;
    let fedShare = _.get(
      this.props.awardRecommendation,
      'payload.budget.share.fedShare',
      []
    );
    if (!Array.isArray(fedShare)) {
      fedShare = [fedShare];
    }
    let awardAmount = _.sum(fedShare).toFixed(2);

    if (error) return <Error />;
    else {
      return (
        <React.Fragment>
          <Header as={headerSize || 'h1'}>Funding Information</Header>
          <Segment>
            <FemaGoTable type="static" summary="Funding Information">
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>
                    Commitment number - Sequence number
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Commitment end date</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Available amount</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>
                    Program name abbreviation
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>ACCS code</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>
                    Amount awarded this action (+/-)
                  </FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {commitments &&
                  commitments.map((row, index) => {
                    let {
                      commitmentNumberId,
                      commitmentEndDate,
                      commitmentAvailableAmount,
                      accsline,
                      commitmentLineNumber,
                    } = row;

                    return (
                      <FemaGoTable.Row key={index}>
                        <FemaGoTable.TextCell>
                          {commitmentNumberId + ' - ' + commitmentLineNumber}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {convertDateForDisplay(commitmentEndDate, true)}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {convertValueToDollar(commitmentAvailableAmount)}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {
                            this.props.fundingOpportunityData
                              .fundingOpportunityCommitment[0].financialAbbreviationCodeId
                          }
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>{accsline}</FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {convertValueToDollar(awardAmount)}
                        </FemaGoTable.TextCell>
                      </FemaGoTable.Row>
                    );
                  })}
              </FemaGoTable.Body>
            </FemaGoTable>
          </Segment>
        </React.Fragment>
      );
    }
  }
}

export const formatLineNumber = (lineNumber) => {
  while (lineNumber.length < 3) lineNumber = '0' + lineNumber;
  return lineNumber;
};

export const mapStateToProps = (state, ownProps) => {
  const props = {};
  props.awardRecommendation = _.get(
    state,
    'dynamicComponent.context.awardRecommendation'
  );
  props.fundingOpportunityData = _.get(
    state,
    'dynamicComponent.context.fundingOpportunityData'
  );
  props.processVariables = _.get(
    state,
    'dynamicComponent.context.workflowTask.processVariables'
  );
  props.token = state.auth.token;
  return props;
};

export const mapDispatchToProps = (dispatch) => ({
  getCommitment: (token, commitmentId) => {
    let action = ApiActions.commitment.getCommitment(token, commitmentId);
    const res = dispatch(action);
    return res;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FundingInformationTable);
